import React from 'react';
import { Checkbox, Icon, Tooltip } from 'antd';
import {  FormattedMessage } from 'react-intl';
import styles from './AllNotificationsActivator.module.scss';
import message from '../../../../Containers/ManualSearchV2/ManualSearchMessages';

export function getCheckboxTooltipTitle(isActivated) {
  if (isActivated) return <FormattedMessage {...message.deactivateAllSettingsLabel} />;
  return <FormattedMessage {...message.activateAllSettingsLabel} />;
}

export default function AllNotificationsActivator(props) {
  const { checked, loading, onChange, disabled } = props;
  const onActivateAll = e => {
    const value = e.target.checked;
    onChange(value);
  };
  const checkbox = <Checkbox checked={checked} onChange={onActivateAll} disabled={loading || disabled} />;
  const checkboxWithTooltip = (
    <Tooltip title={getCheckboxTooltipTitle(checked)}>
      <Checkbox checked={checked} onChange={onActivateAll} disabled={loading || disabled} />
    </Tooltip>
  );
  return (
    <div className={styles.content}>
      {disabled ? checkbox : checkboxWithTooltip}
      <FormattedMessage {...message.activateAllLabel} />
      {loading ? <Icon type="loading" /> : null}
    </div>
  );
}
